<template> <!-- OK -->
  <div class="player-management">
    <h2>Gerenciamento de Jogadores</h2>
    <button @click="goBack" class="back-button">Voltar para Administração</button>
    <div class="filter-container">
      <label for="stage">Etapa:</label>
      <select v-model="selectedStageId" @change="fetchGroups" id="stage">
        <option v-for="stage in stages" :key="stage.id" :value="stage.id">
          {{ stage.name }}
        </option>
      </select>
    </div>
    <div class="filter-container">
      <label for="sortOrder">Ordenar por:</label>
      <select v-model="sortOrder" @change="sortPlayers" id="sortOrder">
        <option value="username">Nome</option>
        <option value="group">Grupo</option>
      </select>
    </div>
    <div class="table-wrapper">
      <table class="player-table">
        <thead>
        <tr>
          <th>Nome</th>
          <th>Grupo</th>
          <th>Ações</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="player in sortedPlayers" :key="player.id">
          <td>{{ player.User.fullName }}</td>
          <td>{{ getGroupName(player.id) }}</td>
          <td>
            <button @click="confirmDeletePlayer(player.id)" class="delete-button">Deletar</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import playerService from '../services/playerService';
import stageService from '../services/stageService';
import groupService from '../services/groupService';
import groupPlayerService from '../services/groupPlayerService';

export default {
  name: 'PlayerManagement',
  data() {
    return {
      players: [],
      stages: [],
      groups: [],
      groupPlayers: [],
      sortOrder: 'username',
      selectedStageId: null,
    };
  },
  computed: {
    sortedPlayers() {
      if (this.sortOrder === 'username') {
        return this.players.slice().sort((a, b) => {
          if (a.User && b.User) {
            return a.User.username.localeCompare(b.User.username);
          }
          return 0;
        });
      } else if (this.sortOrder === 'group') {
        return this.players.slice().sort((a, b) => {
          const groupA = a.groupName || '';
          const groupB = b.groupName || '';
          return groupA.localeCompare(groupB);
        });
      }
      return this.players;
    }
  },
  methods: {
    async fetchPlayers() {
      try {
        const response = await playerService.getAllPlayers();
        this.players = response.data;
      } catch (error) {
        console.error('Erro ao buscar jogadores', error);
      }
    },
    async fetchStages() {
      try {
        const response = await stageService.getAllStages();
        this.stages = response.data;
        if (this.stages.length > 0) {
          this.selectedStageId = this.stages[0].id;
          await this.fetchGroups();
        }
      } catch (error) {
        console.error('Erro ao buscar etapas', error);
      }
    },
    async fetchGroups() {
      if (this.selectedStageId) {
        try {
          const response = await groupService.getGroupsByStage(this.selectedStageId);
          this.groups = response.data;
          await this.fetchGroupPlayers();
        } catch (error) {
          console.error('Erro ao buscar grupos', error);
        }
      }
    },
    async fetchGroupPlayers() {
      try {
        const response = await groupPlayerService.getAllGroupPlayers();
        this.groupPlayers = response.data;
        this.assignPlayersToGroups();
      } catch (error) {
        console.error('Erro ao buscar jogadores dos grupos', error);
      }
    },
    assignPlayersToGroups() {
      this.players.forEach(player => {
        const groupPlayer = this.groupPlayers.find(gp => gp.playerId === player.id);
        if (groupPlayer) {
          const group = this.groups.find(g => g.id === groupPlayer.groupId);
          player.groupName = group ? group.name : 'Sem Grupo';
        } else {
          player.groupName = 'Sem Grupo';
        }
      });
    },
    async deletePlayer(playerId) {
      try {
        await playerService.deletePlayer(playerId);
        this.fetchPlayers();
      } catch (error) {
        console.error('Erro ao deletar jogador:', error);
      }
    },
    confirmDeletePlayer(playerId) {
      const player = this.players.find(p => p.id === playerId);
      if (confirm(`Você tem certeza que deseja deletar o jogador ${player.User.username}?`)) {
        this.deletePlayer(playerId);
      }
    },
    goBack() {
      this.$router.push('/admin');
    },
    sortPlayers() {
      if (this.sortOrder === 'username') {
        this.sortedPlayers = [...this.players].sort((a, b) => a.User.username.localeCompare(b.User.username));
      } else if (this.sortOrder === 'group') {
        this.sortedPlayers = [...this.players].sort((a, b) => a.groupName.localeCompare(b.groupName));
      }
    },
    getGroupName(playerId) {
      const player = this.players.find(p => p.id === playerId);
      return player ? player.groupName : 'Sem Grupo';
    }
  },
  async created() {
    await this.fetchPlayers();
    await this.fetchStages();
  }
};
</script>

<style scoped>
.player-management {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #F0F4F7;
  padding: 2rem;
}

.player-management h2 {
  margin-bottom: 2rem;
  color: #003366;
  font-size: 2.5rem;
}

.back-button {
  text-decoration: none;
  color: white;
  background-color: #0056B3;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s;
  margin-bottom: 1rem;
}

.back-button:hover {
  background-color: #003366;
}

.filter-container {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.player-table {
  width: 100%;
  max-width: 1200px;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.player-table th,
.player-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #DDD;
}

.delete-button {
  text-decoration: none;
  color: white;
  background-color: #E74C3C;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s;
  border: none;
}

.delete-button:hover {
  background-color: #C0392B;
}

@media (max-width: 768px) {
  .player-management h2 {
    font-size: 2rem;
  }

  .player-table th,
  .player-table td {
    padding: 0.5rem;
    font-size: 0.9rem;
  }

  .back-button {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }

  .delete-button {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }
}

@media (max-width: 425px) {
  .player-management h2 {
    font-size: 1.5rem;
    text-align: center;
  }

  .player-table th,
  .player-table td {
    padding: 0.3rem;
    font-size: 0.8rem;
  }

  .back-button {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }

  .delete-button {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }
}
</style>
  